'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _query = require('utilities/query');

var _userIngredients = require('./user-ingredients.component');

var _userIngredients2 = _interopRequireDefault(_userIngredients);

var _userIngredients3 = require('./user-ingredients.service');

var _userIngredients4 = _interopRequireDefault(_userIngredients3);

var _userIngredientForm = require('./user-ingredient-form/user-ingredient-form.module');

var _userIngredientForm2 = _interopRequireDefault(_userIngredientForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin.user-ingredients', [_angularUiRouter2.default, _userIngredientForm2.default]).component('userIngredients', _userIngredients2.default).service('UserIngredientsService', _userIngredients4.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('userIngredients', {
    parent: 'admin',
    url: '/user-ingredients',
    component: 'userIngredients',
    resolve: {
      flex: function flex() {
        return '100';
      },
      layout: function layout() {
        return 'column';
      },
      query: function query(UserIngredientsService) {
        return UserIngredientsService.getDefaultQuery();
      },
      ingredients: function ingredients(query, UserIngredientsService) {
        return UserIngredientsService.search(query).then(function (r) {
          return (0, _query.transformODataResponse)(r);
        });
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/user-ingredients/user-ingredients.module.js